var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose([""], [""]);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from "react";
import styled from "styled-components";

var Error = styled.p(_templateObject);
var Wrapper = styled.div(_templateObject);
var Label = styled.label(_templateObject);

var wrapFieldForFormik = function wrapFieldForFormik(Component) {
  return function (_ref) {
    var _ref$field = _ref.field,
        field = _ref$field === undefined ? {} : _ref$field,
        _ref$form = _ref.form,
        form = _ref$form === undefined ? {} : _ref$form,
        label = _ref.label,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, ["field", "form", "label", "className"]);

    var error = field.name && form.touched[field.name] && form.errors[field.name];
    var FieldComponent = React.createElement(
      Wrapper,
      { className: className },
      !!label && React.createElement(
        Label,
        { htmlFor: field.name },
        label
      ),
      React.createElement(Component, _extends({ id: field.name, error: error }, field, props)),
      !!error && React.createElement(
        Error,
        null,
        error
      )
    );
    return FieldComponent;
  };
};

export { wrapFieldForFormik };
wrapFieldForFormik.parts = {
  Wrapper: Wrapper,
  Error: Error,
  Label: Label
};